export default __webpack_public_path__ + "static/media/profile.dc080ec5.jpg";